import { c as _c } from "react/compiler-runtime";
export interface RowTitleProps {
  title: string;
  columnCount?: number;
}
const rowTitleClasses = ["text-gray-m10 font-semibold", "text-base sm:text-lg", "leading-[1.375rem] sm:leading-8", "tracking-normal sm:tracking-[0.18px]", "t2-dark:text-white"].join(" ");
export const RowTitle = t0 => {
  const $ = _c(5);
  const {
    title,
    columnCount
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="min-w-full border-b border-gray-m2 t2-dark:border-b-white"><span className="sticky left-0 inline-block py-4 px-6">{title}</span></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== columnCount || $[3] !== t1) {
    t2 = <tr className={rowTitleClasses}><td colSpan={columnCount}>{t1}</td></tr>;
    $[2] = columnCount;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};